import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Paper,
  Typography,
  Box,
  Card,
  CardContent,
  CardActionArea,
  Stack,
  Chip,

  Button,
} from '@mui/material';
import { LocalShipping, People, Business } from '@mui/icons-material';
import { IconButton, Menu, MenuItem, Divider } from '@mui/material';
import { useAuth } from '../context/AuthProvider';
import { AccountCircle } from '@mui/icons-material';
import ResetPasswordModal from '../components/password-reset/ResetPassword';


interface Deposito {
  cod_dep: number;
  descricao: string;
  nome_completo: string;
}


const HomePage: React.FC = () => {
  const navigate = useNavigate();
  const [selectedDeposito, setSelectedDeposito] = useState < Deposito | null > (null);
  const [roleName, setRoleName] = useState < string > ('');
  const [isResetModalOpen, setIsResetModalOpen] = useState(false);

  const [isDriver, setIsDriver] = useState < boolean > (true)
  const { user, logout } = useAuth();
  const [anchorEl, setAnchorEl] = useState < null | HTMLElement > (null);
  const open = Boolean(anchorEl);

  const handleMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    logout();
  };

  useEffect(() => {
    // retirar do localStorage e extrair role_name (com fallback pra role.name)
    const storedUser = localStorage.getItem('user');
    let roleNameLocal = '';
    if (storedUser) {
      try {
        const parsed = JSON.parse(storedUser);
        roleNameLocal = parsed.role_name ?? parsed.Role?.name ?? parsed.role?.name ?? '';
      } catch (e) {
        console.error('Erro ao parsear user:', e);
      }
    }

    // normalizar e checar se contém a parte "driver"
    const normalized = roleNameLocal.trim().toLowerCase();
    const parts = normalized.split(/[-_\s]+/);
    const isDriverLocal = parts.includes('driver');

    // atualizar states
    setRoleName(normalized);  // <---- esta linha era a que faltava
    setIsDriver(isDriverLocal);
  }, []);


  useEffect(() => {
    const storedDeposito = localStorage.getItem('selectedDeposito');
    if (storedDeposito) {
      const deposito = JSON.parse(storedDeposito);
      setSelectedDeposito(deposito);
    } else {
      // Se não houver depósito selecionado, redireciona para a página de seleção de empresa
      navigate('/', { replace: true });
    }
  }, [navigate]);

  useEffect(() => {
    const storedDeposito = localStorage.getItem('selectedDeposito');
    if (storedDeposito) {

    }
  }, []);

  const handleChangeDeposito = () => {
    navigate('/deposito-selection');
  };

  const menuItems = [
    {
      title: 'Check-in',

      description: 'Acesse via QR Code para registrar sua entrada na fila',
      icon: <LocalShipping sx={{ fontSize: 60 }} />,
      path: `/checkin`,
      color: 'primary.main',
    },
    {
      title: 'Painel Faturista',
      description: 'Gerencie a fila, finalize atendimentos e acompanhe os status.',
      icon: <People sx={{ fontSize: 60 }} />,
      path: `/billing`,
      color: 'warning.main',
    },
  ];

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #004792 0%, #38A845 100%)',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {/* Header fixo e responsivo */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          px: { xs: 2, md: 4 },
          py: 2,
        }}
      >
        <Typography
          variant="h6"
          sx={{
            color: 'white',
            fontWeight: 'bold',
            fontSize: { xs: '1.1rem', sm: '1.4rem' },
            textAlign: 'left',
          }}
        >
          Nimo Energia
        </Typography>

        <IconButton onClick={handleMenuClick} sx={{ color: 'white' }}>
          <AccountCircle sx={{ fontSize: 36 }} />
        </IconButton>

        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          <MenuItem disabled>
            {user?.name || user?.username || user?.email || 'Usuário'}
          </MenuItem>
          <Divider />
          <MenuItem onClick={() => setIsResetModalOpen(true)}>Trocar Senha</MenuItem>
          <MenuItem onClick={handleLogout}>Sair</MenuItem>
        </Menu>
      </Box>

      {/* Conteúdo principal */}
      <Container
        maxWidth="md"
        sx={{
          flexGrow: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          pb: 6,
        }}
      >
        <Paper
          elevation={8}
          sx={{
            p: { xs: 3, md: 6 },
            borderRadius: 4,
            width: '100%',
            textAlign: 'center',
          }}
        >
          {/* Logos */}
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            spacing={3}
            justifyContent="center"
            alignItems="center"
            sx={{ mb: 4 }}
          >
            <Box
              component="img"
              src="/images/logo_nimo_energia_quadrada.png"
              alt="Nimo Energia"
              sx={{
                height: { xs: 70, md: 100 },
                objectFit: 'contain',
              }}
            />
          </Stack>

          {/* Título e subtítulo */}
          <Typography
            variant="h3"
            component="h1"
            fontWeight="bold"
            gutterBottom
            sx={{
              fontSize: { xs: '1.8rem', sm: '2.4rem', md: '3rem' },
              lineHeight: 1.2,
              wordBreak: 'break-word',
            }}
          >
            Sistema de Check-in de Motoristas
          </Typography>
          <Typography
            variant="subtitle1"
            color="text.secondary"
            sx={{
              fontSize: { xs: '1rem', sm: '1.1rem' },
              mb: 3,
            }}
          >
            Gerencie a fila de carregamento de veículos de forma eficiente e em tempo real
          </Typography>

          {/* Depósito selecionado */}
          {selectedDeposito && (
            <Box
              sx={{
                mt: 2,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                gap: 2,
                flexWrap: 'wrap',
              }}
            >
              <Chip
                icon={<Business />}
                label={`Depósito: ${selectedDeposito?.nome_completo || selectedDeposito?.descricao || ''}`}
                color="primary"
                size="medium"
                sx={{ fontSize: '1rem', py: 2 }}
              />
              {(roleName === 'admin' || roleName === 'manager') && (
                <Button variant="outlined" size="small" onClick={handleChangeDeposito}>
                  Alterar
                </Button>
              )}
            </Box>
          )}

          {/* Cards de menu */}
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: {
                xs: '1fr',
                sm: isDriver ? '1fr' : 'repeat(2, 1fr)',
              },
              gap: 3,
              mt: 5,
            }}
          >
            {menuItems.map((item) => {
              if (item.title === 'Painel Faturista' && isDriver) return null;
              return (
                <Card
                  key={item.path}
                  elevation={4}
                  sx={{
                    transition: 'all 0.3s',
                    '&:hover': { transform: 'translateY(-6px)', boxShadow: 8 },
                  }}
                >
                  <CardActionArea onClick={() => navigate(item.path)}>
                    <Box
                      sx={{
                        bgcolor: item.color,
                        p: 3,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        minHeight: 100,
                      }}
                    >
                      <Box sx={{ color: 'white' }}>{item.icon}</Box>
                    </Box>
                    <CardContent sx={{ textAlign: 'center', p: 3 }}>
                      <Typography
                        variant="h6"
                        fontWeight="bold"
                        gutterBottom
                        sx={{ fontSize: { xs: '1.1rem', sm: '1.3rem' } }}
                      >
                        {item.title}
                      </Typography>
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{ fontSize: { xs: '0.9rem', sm: '1rem' } }}
                      >
                        {item.description}
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              );
            })}
          </Box>
        </Paper>
      </Container>

      <ResetPasswordModal
        open={isResetModalOpen}
        onClose={() => setIsResetModalOpen(false)}
        username={user?.name || user?.username || user?.email || 'Usuário'}
      />
    </Box>
  );
};

export default HomePage;
